<template>
  <modal-wrapper
    title="Nueva licencia"
    :isVisible="modelValue"
    :showSaveButton="false"
    @cerrar-modal="cerrarModal"
  >
    <mensaje-invalidos v-if="v$.$error" class="m-0 my-3" />
    <div class="formgrid grid my-3">
      <div class="col-12">
        <p-float-label label="Código" required>
          <input-text
            v-model="v$.IdTCompania.$model"
            :class="{ 'p-invalid': v$.IdTCompania.$error }"
          />
        </p-float-label>
        <small v-if="v$.IdTCompania.$error" class="p-error mt-1">
          {{ v$.IdTCompania.$errors[0].$message }}
        </small>
      </div>
      <div class="col-12 mt-5">
        <p-float-label label="Razón social" required>
          <input-text
            v-model="v$.DescripcionCompania.$model"
            :class="{ 'p-invalid': v$.DescripcionCompania.$error }"
          />
        </p-float-label>
        <small v-if="v$.DescripcionCompania.$error" class="p-error mt-1">
          {{ v$.DescripcionCompania.$errors[0].$message }}
        </small>
      </div>
      <div class="col-12 mt-5">
        <p-float-label label="Login" required>
          <input-text
            v-model="v$.Usuario.$model"
            :class="{ 'p-invalid': v$.Usuario.$error }"
          />
        </p-float-label>
        <small v-if="v$.Usuario.$error" class="p-error mt-1">
          {{ v$.Usuario.$errors[0].$message }}
        </small>
      </div>
      <div class="col-12 mt-5 flex justify-content-end">
        <button-element
          label="Crear licencia"
          icon="pi pi-check"
          @click="crearLicenciaHandler"
        />
      </div>
    </div>
  </modal-wrapper>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { useVuelidate } from "@vuelidate/core";
import { helpers, maxLength, required } from "@vuelidate/validators";
import { alertStatus } from "@/helpers/alertStatus";
import * as alerts from "@/helpers/alertMessages";
import { crearLicencia } from "../services/soporte-cmms";

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "creada"]);

const store = useStore();
const toast = useToast();

const form = reactive({
  IdTCompania: "",
  DescripcionCompania: "",
  Usuario: "",
});

const erroresServidor = ref({});

const reglas = {
  IdTCompania: {
    required: helpers.withMessage("El código es obligatorio.", required),
    maxLength: helpers.withMessage(
      "El código no puede superar 10 caracteres.",
      maxLength(10)
    ),
  },
  DescripcionCompania: {
    required: helpers.withMessage(
      "La razón social es obligatoria.",
      required
    ),
    maxLength: helpers.withMessage(
      "La razón social no puede superar 255 caracteres.",
      maxLength(255)
    ),
  },
  Usuario: {
    required: helpers.withMessage("El login es obligatorio.", required),
    maxLength: helpers.withMessage(
      "El login no puede superar 50 caracteres.",
      maxLength(50)
    ),
  },
};

const v$ = useVuelidate(reglas, form, { $externalResults: erroresServidor });

const resetModal = () => {
  form.IdTCompania = "";
  form.DescripcionCompania = "";
  form.Usuario = "";
  erroresServidor.value = {};
  v$.value.$reset();
  emit("update:modelValue", false);
};

const cerrarModal = async () => {
  if (v$.value.$anyDirty) {
    const confirmacion = await alerts.descartarCambios();
    if (!confirmacion?.isConfirmed) return;
  }

  resetModal();
};

const crearLicenciaHandler = async () => {
  erroresServidor.value = {};

  const esValido = await v$.value.$validate();
  if (!esValido) return;

  store.commit("setIsLoading", true);
  const { data, status } = await crearLicencia(form);
  store.commit("setIsLoading", false);

  if (status === 201) {
    toast.add({
      ...alerts.creado,
      detail: data.message,
    });
    emit("creada");
    resetModal();
    return;
  }

  if (status === 422 && data?.errors) {
    erroresServidor.value = data.errors;
    return;
  }

  alertStatus(status, data);
};
</script>
